import FlatButton from 'material-ui/FlatButton';
import React from 'react';
import styled from 'styled-components';

import { Centered500 } from '../arkulpa-fec/components/Container';
import { HeadlineH2 } from '../arkulpa-fec/components/Text';
import ActionButtonRow from '../arkulpa-fec/components/ActionButtonRow';

const Heading = styled(HeadlineH2)`
  margin-top: 20px;
`;

const Wrapper = styled(Centered500)`
  padding: 10px 40px;
`;

export default ({history}) =>
  <Wrapper>
    <Heading>Registrierung abgeschlossen</Heading>
    <p>Danke für deine Registrierung!</p>
    <p>Wir überprüfen deine Angaben. Wenn alles passt, erhältst du eine E-Mail, dass dein Konto aktiviert wurde.</p>
    <ActionButtonRow>
      <FlatButton onClick={() => history.push('/login')} label="zurück zum Login" />
    </ActionButtonRow>
  </Wrapper>;



// WEBPACK FOOTER //
// ./src/containers/RegisterSuccessPage.js